module.exports = __webpack_public_path__ + "img/9788959523269.0c6597db.jpg";